// extracted by mini-css-extract-plugin
export default {"special-offer-card":"WlUnrHskBHLuXNM","special-offer-card-text":"eC4D9AYpn7f_Zaq","special-offer-card-img":"s6nv5tamhN3kpHA"};